// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ecc73e5a","313":"ce7bfea5","453":"10720acd","501":"42d43121","699":"99fe6b0e","732":"8c8ff707","811":"3ed8939a","906":"33303703","926":"cf140cea"}[chunkId] + ".chunk.js";
};